import React from 'react';
import { Table } from 'semantic-ui-react';
import {
  columnDataExists,
  columnName,
  columnRowCount,
  columnValidationDate,
  columnTools,
  hasColumn,
} from '@/constants/fields';
import NameCell from '@/components/table/NameCell';
import SelectableRow from '@/components/table/SelectableRow';
import SimpleCell from '@/components/table/SimpleCell';
import DataManagementDictionaryActionsCell from './DataManagementDictionaryActionsCell';
import DataManagementDictionaryDataExistsCell from './DataManagementDictionaryDataExistsCell';
import { validationStatusIconProps } from '../helper';
import DataManagementValidationDateCell from './DataManagementValidationDateCell';
import DataManagementDictionaryToolsMenu from './DataManagementDictionaryToolsMenu';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';
import ReportsEvents from '../../reports/hooks/events';

const DataManagementDictionariesTableRow = ({
  category,
  code,
  columns,
  dictionaryCode,
  upward,
}) => {
  const {
    allowConversion,
    dataTableExists,
    dictionaryName,
    disableConvert,
    disableValidate,
    isLoading,
    lastValidationDate,
    rowCount,
    selected,
    valid,
  } = Selectors.useDataManagementDictionaryItem(category, code, dictionaryCode);
  const showStatus = Events.useShowValidateDictionaryDataStatus(category, { code });
  const showReports = ReportsEvents.useShowDictionaryReports(category, { code: dictionaryCode });
  const validate = Events.useValidateDictionaryData(category, { code });
  const convert = Events.useConvertDictionaryData(category, { code });

  return (
    <SelectableRow
      className="aridhia-data-management-table-row"
      selected={selected}
      label={dictionaryName}
      columns={columns}
      onClick={() => showStatus({ dictionaryCode, dictionaryName, inDialog: false })}
      error={valid === false}
      positive={valid === true}
      selectable={!disableValidate}
    >
      {hasColumn(columns, columnName) && (
        <NameCell
          name={dictionaryName}
          icon={validationStatusIconProps(valid).name}
          iconColour={validationStatusIconProps(valid).colour}
          message={validationStatusIconProps(valid).message}
          loading={isLoading}
          className="data-management-dictionary-name"
        />
      )}
      {hasColumn(columns, columnDataExists) && (
        <DataManagementDictionaryDataExistsCell dataTableExists={dataTableExists} />
      )}
      {hasColumn(columns, columnRowCount) && (<SimpleCell textAlign="right" content={rowCount} />)}
      {hasColumn(columns, columnValidationDate) && (
        <DataManagementValidationDateCell lastValidationDate={lastValidationDate} />
      )}
      {hasColumn(columns, columnTools) && (
        <>
          <DataManagementDictionaryActionsCell
            allowConversion={allowConversion}
            convert={convert}
            dictionaryCode={dictionaryCode}
            dictionaryName={dictionaryName}
            disableConvert={disableConvert}
            disableValidate={disableValidate}
            isLoading={isLoading}
            validate={validate}
          />
          <Table.Cell collapsing>
            <DataManagementDictionaryToolsMenu
              allowConversion={allowConversion}
              convert={convert}
              dictionaryCode={dictionaryCode}
              dictionaryName={dictionaryName}
              disableConvert={disableConvert || isLoading}
              disableValidate={disableValidate || isLoading}
              validate={validate}
              showReports={showReports}
              upward={upward}
            />
          </Table.Cell>
        </>
      )}
    </SelectableRow>
  );
};

export default DataManagementDictionariesTableRow;
